import { Section } from '@models/ShopDetails';

export default function MenuShelves({ total, count, sections }) {
  return {
    total,
    count,
    sections:
      sections?.map(section =>
        Section({
          id: section.id,
          name: section.name,
          image: section.image,
          customImage: section.customImage,
          requiresAgeCheck: section.requiresAgeCheck,
          products: section.products,
          totalProducts: section.totalProducts,
        }),
      ) || [],
  };
}
